import React, {ReactElement, useMemo} from 'react';

import classNames from 'classnames';
import {connect} from 'react-redux';

import {ApplicationStoreType} from 'desktop/store';

import {CartGiftBanner} from '../../features/vistaPlus/cartGiftBanner/cartGiftBanner';
import {getQuoteItems} from '../../store/selectors';
import {CartItemType} from '../../types';

import {CartItem} from '../cartItem/cartItem';

import s from './filteredCartList.scss';

export type PropsType = {
    items: Array<CartItemType>;
};

const VISTA_PLUS_TRIAL_SKU = '181-000003';

/**
 * Returns a gift element if needed
 * @param {CartItemType} - cart item
 * @returns {React.ReactElement} - gift banner
 */
const getGiftBanner = ({sku, sortOrder}: CartItemType) =>
    sku === VISTA_PLUS_TRIAL_SKU ? (
        <li className={s.item} data-test-name="cartItem" key={`${sortOrder}_gift`}>
            <CartGiftBanner giftType="freeGlasses" />
        </li>
    ) : null;

/**
 * Filtered cart list by active
 * @param {PropsType} props - data
 * @return {ReactElement} - component
 */
export const FilteredCartList: React.FC<PropsType> = ({items}): ReactElement => {
    const sortedItemsFirstOutOfStocks = useMemo(() => {
        return [...items].sort((x, y) => {
            const xOutOfStock = Number(x.stock.isOutOfStock);
            const yOutOfStock = Number(y.stock.isOutOfStock);

            return yOutOfStock - xOutOfStock;
        });
    }, [items]);

    return (
        <ul className={s.list}>
            {!items.length && <div className={s.placeholder} />}
            {sortedItemsFirstOutOfStocks.map(item => (
                <React.Fragment key={item.sortOrder}>
                    <li
                        className={classNames(s.item, {
                            [s.itemRedesignGlasses]:
                                item.type === 'eyeglasses' || item.type === 'sunglasses',
                        })}
                        data-test-name="cartItem"
                    >
                        <CartItem item={item} />
                    </li>
                    {getGiftBanner(item)}
                </React.Fragment>
            ))}
        </ul>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    items: getQuoteItems(store),
});

export const FilteredCartListConnected = connect(mapStateToProps)(FilteredCartList);
